import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';
import { SaleListDetailPurchasePlus } from './plus/SaleListDetailPurchasePlus';
import { SaleListDetailPurchaseTicket } from './ticket/SaleListDetailPurchaseTicket';


export function SaleListDetailPurchase(props: any) {

  const sale = props.sale;

  const isPc = useContext(cmnContext).isPc;

  const grayColor = useContext(SaleListContext).grayColor;
  const isFullAccess = useContext(SaleListContext).isFullAccess;

  const [isPlus, setIsPlus] = useState<boolean>(false);
  const [isPaid, setIsPaid] = useState<boolean>(false);

  useEffect(() => {
    if(sale) {
      // プラス無料
      setIsPlus(sale.free_type == 2);
      // 有料
      setIsPaid(
        sale.ticket>0 || sale.price>0
      );
    }
  }, [sale])


  return (
    <>
    {!isFullAccess &&
      <div style={{
        width: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0,
        padding: isPc? '0px 10% 15px' : '0 3% 10px',
        backgroundColor: grayColor,
      }}>

        <div style={{
          backgroundColor: 'black',
          height: 1,
          margin: isPc? '0px 0 15px' : '0px 0 10px',
        }}></div>

        {/* プラス無料 */}
        {isPlus &&
          <SaleListDetailPurchasePlus
            isPaid={isPaid}
          />
        }

        {/* チケット・クレカ */}
        {isPaid &&
          <SaleListDetailPurchaseTicket
            sale={sale}
            isPlus={isPlus}
          />
        }

      </div>
    }
    </>
  );
}